import { useMemo } from 'react';

import { Banners } from '@sorare/core/src/components/layout/Banners';
import { MobileAppBottomPortalReceiver } from '@sorare/core/src/components/navigation/AppNavigation';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import {
  SaleType,
  TOKENS_STACKED_LIMIT,
  createCardSorts,
} from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/nba';

import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import { useDefaultFilters } from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { instantBuyMarketFilters } from '@sorare/marketplace/src/searchCards/mlb/cardFilters';

import { BaseballCardSearch } from 'components/searchCards/BaseballCardSearch';

const InstantBuy = () => {
  const {
    flags: { useMlbSeasonAverageScore = true },
  } = useFeatureFlags();

  const cardSorts = useMemo(
    () =>
      createCardSorts({
        indexPrefix: 'Cards On Sale',
        withHighestAverageScore: true,
        withEndingSoon: false,
        withNew: false,
        withPopularPlayer: true,
      }),
    []
  );

  const defaultSort = 'Cards On Sale Popular Player';

  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();
  useTitleAndDescription(
    metadatas.instantBuy.title,
    metadatas.instantBuy.description
  );

  const filters = useDefaultFilters({ primaryOffer: true, bundled: false });
  const cardsFilter = useMemo(
    () => instantBuyMarketFilters(useMlbSeasonAverageScore),
    [useMlbSeasonAverageScore]
  );

  return (
    <>
      {!!(!isIosApp || isMarketAuthorizedIosApp) && <Banners />}
      <MarketRoot>
        <BaseballCardSearch
          sorts={cardSorts}
          defaultSort={defaultSort}
          cardFilters={cardsFilter}
          defaultFilters={filters}
          analyticsTags={['InstantBuy', 'MLB']}
          topic={{ type: 'instantBuy', label: '' }}
          onlyPrimary
          distinct={TOKENS_STACKED_LIMIT}
          hideStackedSwitch
          stackableTypes={[SaleType.PRIMARY_OFFER]}
          removeFinishedPrimaryBuys
          hideSorareUser
        />
      </MarketRoot>
      {!!isIosApp && (
        <MobileAppBottomPortalReceiver id="above-bottom-bar-portal" />
      )}
    </>
  );
};

export default InstantBuy;
